var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.867,
    height: 32,
    viewBox: "0 0 26.867 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Android",
    transform: "translate(-461 -444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M142.3,191.931a1.3,1.3,0,0,1-1.3,1.3H125.942a1.3,1.3,0,0,1-1.3-1.3V178.477c3.947-.014,13.156-.014,17.661,0Z",
    transform: "translate(340.968 276.326)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M173.392,22.172a.3.3,0,0,1-.13.4h0a.3.3,0,0,1-.4-.131l-1.9-3.71a.3.3,0,0,1,.131-.4h0a.3.3,0,0,1,.4.13l1.9,3.71Z",
    transform: "translate(297.796 425.732)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M303.113,21.9a.3.3,0,0,1-.41.108h0a.3.3,0,0,1-.108-.408l2.085-3.61a.3.3,0,0,1,.409-.109h0a.3.3,0,0,1,.111.408L303.112,21.9Z",
    transform: "translate(175.008 426.159)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M403.267,183.064a1.9,1.9,0,0,1-1.9,1.9h0a1.9,1.9,0,0,1-1.9-1.9v-8.3a1.9,1.9,0,0,1,1.9-1.9h0a1.894,1.894,0,0,1,1.9,1.9Z",
    transform: "translate(84.6 281.544)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M59.836,183.064a1.9,1.9,0,0,1-1.9,1.9h0a1.9,1.9,0,0,1-1.9-1.9v-8.3a1.894,1.894,0,0,1,1.9-1.9h0a1.9,1.9,0,0,1,1.9,1.9Z",
    transform: "translate(404.957 281.544)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M182.738,324.378a1.9,1.9,0,0,1-1.9,1.9h0a1.9,1.9,0,0,1-1.894-1.9v-8.3a1.9,1.9,0,0,1,1.894-1.9h0a1.9,1.9,0,0,1,1.9,1.9Z",
    transform: "translate(290.312 149.726)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M280.623,324.378a1.9,1.9,0,0,1-1.9,1.9h0a1.9,1.9,0,0,1-1.9-1.9v-8.3a1.9,1.9,0,0,1,1.9-1.9h0a1.9,1.9,0,0,1,1.9,1.9Z",
    transform: "translate(199.004 149.726)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M132.259,46.663a9.007,9.007,0,0,0-8.918,8.022h17.835a9,9,0,0,0-8.917-8.022Zm-4.024,4.863a.74.74,0,1,1,.74-.741A.741.741,0,0,1,128.235,51.526Zm8.064,0a.74.74,0,1,1,.741-.741A.741.741,0,0,1,136.3,51.526Z",
    transform: "translate(342.18 399.273)",
    fill: "#a4c639"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/Android.538b6f911d3a5f689e3699dd834d4f53.svg";
export { ForwardRef as ReactComponent };